// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#00375c","primaryColorLight":"#034673","primaryColorLighter":"#0f71b3","primaryColorLightest":"#279ae7"};